<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card v-if="!disableFilters">
        <md-card-header class="md-card-header-icon md-card-header-accent">
          <div class="card-icon">
            <md-icon>filter_list</md-icon>
          </div>
          <h4 class="title">Filtrar</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-layout-item md-size-100">
            <div v-if="enabledFilters.length > 0" style="margin-top: -40px; right: 20px; position: absolute">
              <a href="#" @click.prevent="clearFilters">
                <md-icon>clear</md-icon>
              </a>
            </div>
          </div>

          <form @submit.prevent="executeSearch">
            <div v-for="(filter, filterIndex) in enabledFilters" :key="filterIndex"
              class="md-layout md-layout-item md-size-100">
              <div class="md-layout-item md-size-20 md-form-label">{{ filter.displayName }}</div>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-if="(filter.kind === 'date')" type="date" :name="filter.name" v-model="filter.currentValue"
                    :placeholder="filter.placeholder"></md-input>
                  <md-input v-if="(filter.kind === 'text' || filter.kind === 'long-text') && !filter.mask" type="text"
                    :name="filter.name" v-model="filter.currentValue" :placeholder="filter.placeholder"></md-input>
                  <md-input v-if="(filter.kind === 'text' || filter.kind === 'long-text') && filter.mask" type="text"
                    :name="filter.name" v-model="filter.currentValue" :placeholder="filter.placeholder"
                    v-mask="JSON.parse(JSON.stringify(filter.mask))"></md-input>
                  <md-select v-if="filter.kind === 'select'" :name="filter.name" v-model="filter.currentValue">
                    <md-option v-for="(option, optionIndex) in filter.options" :key="optionIndex" :value="option.value">{{
                      option.name }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <label class="md-layout-item md-size-20 md-label-on-right"></label>
            </div>
          </form>

          <!-- <div class="md-layout md-layout-item md-size-100">
            <div class="md-layout-item md-size-20 md-form-label">Adicionar filtro</div>
            <div class="md-layout-item">
              <md-field>
                <md-select v-model="filterFieldToEnable">
                  <md-option disabled value="none">Selecione um filtro</md-option>
                  <md-option v-for="filter in disabledFilters" :key="filter.name" :value="filter.name">{{ filter.displayName }}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20"></div>
          </div> -->

          <div class="md-layout md-layout-item md-size-100">
            <md-card-actions class="text-center mx-auto">
              <md-button @click.prevent="executeSearch" class="md-accent">Buscar</md-button>
            </md-card-actions>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-accent">
          <div class="card-icon">
            <md-icon>person</md-icon>
          </div>
          <h4 class="title">Resultados</h4>
        </md-card-header>
        <md-card-content>
          <md-table :value="results" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort" class="paginated-table table-striped table-hover">
            <div v-if="loading" class="align-spinner-center">
              <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>
            <md-table-toolbar>
              <md-field>
                <label for="pages">Por página</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option v-for="item in perPageOptions" :key="item" :label="item" :value="item">{{ item }}</md-option>
                </md-select>
              </md-field>
              <div class="md-layout">
                <div class="md-layout-item" style="text-align: right">
                  <md-button v-if="syncEntity" class="md-accent" style="margin: 5px"
                    @click="syncEntity">Atualizar Empresas</md-button>                  
                  <md-button v-if="createEntity" class="md-accent" style="margin: 5px"
                    @click="createEntity">Adicionar</md-button>
                  <md-button v-if="importEntity" class="md-accent" style="margin: 5px"
                    @click="$emit('show');">Importar</md-button>
                  <md-button v-if=" exportEntity " class="md-accent" style="margin: 5px"
                    @click.prevent=" executeExport ">Exportar</md-button>
                </div>
              </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }" @click=" openEntity ? openEntity(item) : () => { } "
              style="cursor: pointer">
              <md-table-cell v-for="( field, fieldIndex ) in  searchFields " :key=" fieldIndex " :md-label=" field.displayName "
                :md-sort-by=" field.name " v-if=" !field.notInResults ">
                <!-- 
                {{ item[field.name] }}
                 -->
                
                {{ field.formatter ? field.formatter(item[field.name]) : item[field.name] }}
                
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Mostrando {{ pagination.from + 1 }} a {{ pagination.from + results.length }} de {{
              pagination.total }}</p>
          </div>
          <pagination class="pagination-no-border pagination-accent" v-model=" pagination.currentPage "
            :per-page=" pagination.perPage " :total=" pagination.total "></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";

export default {
  name: "PaginatedSearch",
  props: {
    schema: Array,
    searchEntities: Function,
    openEntity: Function,
    createEntity: Function,
    exportEntity: Function,
    syncEntity: Function,
    importEntity: Boolean,
    disableFilters: Boolean,
    autoEnable: Boolean,
  },
  components: {
    Pagination,
  },
  data() {
    return {
      currentSortOrder: "asc",
      currentSort: (
        this.schema.find(field => field.defaultSort) || this.schema[0]
      ).name,
      results: [],
      loading: false,
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 50,
        lastPage: 0,
        from: 0
      },
      perPageOptions: [10, 25, 50, 100],
      filterFieldToEnable: "none",
      filters: [],
      render: 0,
    };
  },
  computed: {
    currentPage() {
      return this.pagination.currentPage;
    },
    perPage() {
      return this.pagination.perPage;
    },
    enabledFilters() {
      return this.filters.filter(filter => (filter.enabled && !filter.notInFilters));
    },
    disabledFilters() {
      return this.filters.filter(filter => (!filter.enabled && !filter.notInFilters));
    },
    searchFields() {
      return this.schema.filter(field => (field.search && field.search.show));
    }
  },
  methods: {
    customSort() {
      this.executeSearch();
    },
    executeSearch() {
      this.loading = true;
      const paginationParameters = {
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        orderBy: this.currentSort,
        orderDirection: this.currentSortOrder
      };

      // const enabledModuleFilter = this.enabledFilters.filter(filter => (filter.displayName === "Módulo"));
      // const moduleFilter = this.filters.filter(filter => (filter.displayName === "Módulo"))
      // if (enabledModuleFilter.length === 0)
      //   this.enabledFilters.push(moduleFilter)

      this.enabledFilters.forEach(filter => {

        if (filter.currentValue !== "" && filter.currentValue) {
          let filterValue = filter.currentValue;

          if (filter.endWildcard) {
            filterValue = `${filterValue}%`;
          }

          if (filter.startWildcard) {
            filterValue = `%${filterValue}`;
          }

          paginationParameters[filter.name] = filterValue;
        }
      });

      return this.searchEntities(paginationParameters)
        .then(response => {
          this.results = response.results;
          this.pagination = response.pagination;
          this.loading = false;
        })
        .catch(error => {
          alert("Erro ao executar busca");
          console.log(error);
          this.loading = false;
        });
    },
    executeExport() {
      const paginationParameters = {
        orderBy: this.currentSort,
        orderDirection: this.currentSortOrder
      };

      this.enabledFilters.forEach(filter => {
        if (filter.currentValue !== "") {
          let filterValue = filter.currentValue;

          if (filter.endWildcard) {
            filterValue = `${filterValue}%`;
          }

          if (filter.startWildcard) {
            filterValue = `%${filterValue}`;
          }

          paginationParameters[filter.name] = filterValue;
        }
      });

      return this.exportEntity(paginationParameters);
    },
    clearFilters() {
      this.filters.forEach(filter => {
        filter.enabled = (this.autoEnable && !filter.notInFilters) ? true : false;
        filter.currentValue = undefined;
      });
      this.executeSearch();
    }
  },
  mounted() {
    this.filters = this.searchFields.map(field =>
      Object.assign({
        name: field.name,
        displayName: field.displayName,
        placeholder: field.placeholder,
        kind: field.kind,
        options: field.options,
        currentValue: field.currentValue,
        enabled: field.notInFilters ? false : true,
        mask: field.mask,
        notInFilters: field.notInFilters,
      }, field.search)
    );

    // this.executeSearch();
  },
  watch: {
    schema: {
      deep: true,
      handler() {
        this.filters = this.searchFields.map(field =>
          Object.assign({
            name: field.name,
            displayName: field.displayName,
            placeholder: field.placeholder,
            kind: field.kind,
            options: field.options,
            currentValue: field.currentValue,
            enabled: (this.autoEnable && !field.notInFilters) || false,
            mask: field.mask,
            notInFilters: field.notInFilters,
          }, field.search)
        );
        // const moduleFilter = this.filters.filter(item => item.displayName === "Módulo").length;
        // if(moduleFilter > 0)
        //   this.executeSearch();
      }
    },
    perPage() {
      this.executeSearch();
    },
    currentPage() {
      this.executeSearch();
    },
    filterFieldToEnable() {
      if (this.filterFieldToEnable !== "none") {
        this.filters.find(
          filter => filter.name === this.filterFieldToEnable
        ).enabled = true;
        setTimeout(() => {
          this.filterFieldToEnable = "none";
        }, 10);
      }
    }
  }
};
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.paginated-table .md-table-head.md-sortable .md-table-sortable-icon {
  display: none;
}

.md-progress-spinner {
  margin: 0 auto;
}

.align-spinner-center {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}</style>
